var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "drug-tag" }, [
    _c("span", { staticClass: "name", style: { fontSize: _vm.size + "px" } }, [
      _vm.product.medicineType === "RX"
        ? _c("span", { staticClass: "tag rx" }, [_vm._v("处方药")])
        : _vm._e(),
      _vm._v(
        " " +
          _vm._s(_vm.product.name || _vm.product.goodsName) +
          " " +
          _vm._s(_vm.product.spec) +
          " "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }